fragment SageGiftAccountDifferenceFields on SageGiftAccountDifference {
  id
  kind
  status
  field
  expectedValue
  actualValue
  acceptable
  acceptDescription
  firstSeenAt
  lastSeenAt
  resolvedAt
  actionedAt
  actionedByName
  note
  applyError
  notifiedAt
  sageGiftAccount {
    id
    sageId
    sageName
    sageClass
    status
  }
  fundAccount {
    id
    currency
    fund {
      id
      name
      legalEntity {
        id
        name
      }
    }
  }
}
